import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'wiki-discard-confirmation-modal',
    template: require('./wiki.discard-confirmation-modal.component.html')
})
export class WikiDiscardConfirmationModalComponent {
    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    constructor(public activeModal: NgbActiveModal) {}

    onConfirm(): void {
        this.confirm.emit();
        this.activeModal.close('discard');
    }

    onCancel(): void {
        this.cancel.emit();
        this.activeModal.close('cancel');
    }
}